<script setup>
import { nextTick, ref } from 'vue';
import { Head, useForm } from '@inertiajs/vue3';
import AuthenticationCard from '@/Components/AuthenticationCard.vue';
import AuthenticationCardLogo from '@/Components/AuthenticationCardLogo.vue';
import InputError from '@/Components/InputError.vue';
import InputLabel from '@/Components/InputLabel.vue';
import PrimaryButton from '@/Components/PrimaryButton.vue';
import TextInput from '@/Components/TextInput.vue';
import AuthLayout from '@/Layouts/AuthLayout.vue';
defineOptions({
    layout: AuthLayout
});

const recovery = ref(false);

const form = useForm({
    code: '',
    recovery_code: '',
});

const recoveryCodeInput = ref(null);
const codeInput = ref(null);

const toggleRecovery = async () => {
    recovery.value ^= true;

    await nextTick();

    if (recovery.value) {
        recoveryCodeInput.value.focus();
        form.code = '';
    } else {
        codeInput.value.focus();
        form.recovery_code = '';
    }
};

const submit = () => {
    form.post(route('two-factor.login'));
};
</script>

<template>
    <Head title="Two-factor Confirmation" />

    <AuthenticationCard title="Verify Your Account">
        <template #logo>
            <AuthenticationCardLogo />
        </template>

        <div class="mb-4 text-secondary fs-1">
            <template v-if="! recovery">
                Please confirm access to your account by entering the <span class="fw-medium text-base">authentication code</span> provided by your <span class="fw-medium text-base">authenticator</span> application.
            </template>

            <template v-else>
                Please confirm access to your account by entering one of your <span class="fw-medium text-base">emergency recovery codes</span>.
            </template>
        </div>

        <form @submit.prevent="submit">
            <div v-if="! recovery">
                <v-otp-input
                    v-model="form.code"
                    ref="codeInput"
                    :length="6"
                    focused
                    :error="form.errors.code"
                    required
                ></v-otp-input>
            </div>

            <div v-else class="pt-6">
                <v-text-field
                    v-model="form.recovery_code"
                    ref="recoveryCodeInput"
                    label="Recovery Code"
                    variant="outlined"
                    :error-messages="form.errors.recovery_code"
                    autocomplete="one-time-code"
                    required
                ></v-text-field>
            </div>

            <div class="d-flex flex-column mt-4 ga-4">
                <div>
                    <v-btn type="submit" color="primary" size="x-large" block variant="flat" :disabled="form.processing" :loading="form.processing">Sign In</v-btn>
                </div>
                <div class="d-flex  flex-wrap justify-center align-center">
                    <v-btn type="button" color="primary" class="btn-link text-none" variant="plain" :disabled="form.processing" @click.prevent="toggleRecovery">
                        <template v-if="! recovery">
                            Use a Recovery code
                        </template>

                        <template v-else>
                            Use an Authentication code
                        </template>
                    </v-btn>
                    <span>or</span>
                    <Link :href="route('login')">
                        <v-btn type="button" color="info" class="btn-link text-none" variant="plain" :disabled="form.processing">
                            back to Login
                        </v-btn>
                    </Link>
                </div>
            </div>
        </form>
    </AuthenticationCard>
</template>
